

<h2 *ngIf="next === false" mat-dialog-title class="text-center">
  <b> {{ data.element.instructions.step }} </b>
</h2>

<h2 *ngIf="next === true" mat-dialog-title class="text-center">
  <b> {{ data.element.instructions.header }}</b>
</h2>



<div class="row justify-content-center">


  <h4 *ngIf="next === false" class="text-center"> {{ data.element.instructions.message }} </h4>
  <h4 *ngIf="next === true" class="text-center"> Cliquez ci-dessous pour commencer votre utilisation</h4>

  <div *ngIf="next === false" class="col-10 mt-4 mb-3">
    <div class="row justify-content-center">
    <img mat-card-image style="margin-bottom: 0px !important; max-height: 400px; max-width: 300px!important"
      [src]="sanitizeImageUrl('data:'+data.element.instructions.picture.mimetype+';base64,'+data.element.instructions.picture.file)"
      alt="clem">
    </div>
  </div>


  <div *ngIf="next === false" class="col-12 mt-3">
    <div class="row justify-content-center mb-4">
      <button
        [ngClass]="{'recharge-gradien': data.book.type === 0 || data.book.type === 7,  'autopartage-gradien': data.book.type === 1}"
        mat-raised-button tabindex="-1"  class="col-8 col-md-5 btn" color="primary" (click)="onClickSuivant()">OK</button>
    </div>
  </div>

     <!-- spinner -->
     <div *ngIf="IsLoad === true" class="col-12 mt-3 mb-5 spinner">
      <div class="row justify-content-center mt-4">
        <mat-spinner  [ngClass]="{'recharg': data.book.type === 0 ||data.book.type === 7,  'autopar':data.book.type === 1}"
        class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
      </div>
    </div>

  <div *ngIf="next === true && IsLoad === false" class="col-12 mt-3">
    <div class="row justify-content-center mb-4">
      <button
        [ngClass]="{'recharge-gradien': data.book.type === 0 || data.book.type === 7,  'autopartage-gradien': data.book.type === 1}"
        class="col-8 col-md-5 btn" color="primary" (click)="onClickStart()" mat-raised-button>Start</button>
    </div>

  </div>
</div>